// import plugins
import http from './http'
import maps from './maps/maps'
import toast from './toast'
import dayOfWeek from './day-of-week'
import dayOfWeekTransfer from './day-of-week-transfer'
import moment from 'moment'

/**
 * Default export.
 *
 * @param Vue
 * @param store
 * @param router
 */
export default (Vue, store, router) => {
  // setup http
  Vue.use(http, { store, router })

  // setup toast
  Vue.use(toast, {router})

  maps(Vue)

  Vue.prototype.$dayOfWeekTransfer = dayOfWeekTransfer
  Vue.prototype.$dayOfWeek = dayOfWeek
  Vue.prototype.$moment = moment
}



// WEBPACK FOOTER //
// ./src/plugins/index.js